import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'andrews-page',
  templateUrl: './andrews-page.component.html',
  styleUrls: ['./andrews-page.component.css']
})
export class AndrewsPageComponent implements OnInit {

  constructor(private titleService: Title) { }

  ngOnInit() {
    this.titleService.setTitle('Andrews');
  }

}



// WEBPACK FOOTER //
// ./src/app/andrews-page/andrews-page.component.ts